var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useFlashMessage } from '@app/components/obj.flash-message';
import { axiosClient } from '@app/configure-app';
import { FlashMessageEnum } from '@atomic';
import { CardDeChamado } from '../card';
import { LoadMoreInfo } from './lista-de-chamados.styled';
export var ListaDeChamados = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'abertos' : _b, url = _a.url, _c = _a.isExpandedByDefault, isExpandedByDefault = _c === void 0 ? false : _c, handleOnItemClick = _a.handleOnItemClick;
    var showFlashMessage = useFlashMessage()[0];
    var _d = useState(isExpandedByDefault), isExpanded = _d[0], setExpanded = _d[1];
    var ITEMS_NUMBER_WHEN_COLLAPSED = 4;
    var chamados = useQuery('getChamados' + type, function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosClient.get(url)];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, (_a = response.data) === null || _a === void 0 ? void 0 : _a.data];
                case 2:
                    error_1 = _b.sent();
                    showFlashMessage(FlashMessageEnum.alert, (error_1 === null || error_1 === void 0 ? void 0 : error_1.stack) || error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }).data;
    return (React.createElement(React.Fragment, null,
        (chamados === null || chamados === void 0 ? void 0 : chamados.length) <= 0 && React.createElement("div", { style: { textAlign: 'center' } }, "Sem registros"), chamados === null || chamados === void 0 ? void 0 :
        chamados.map(function (chamado, idx) {
            return (isExpanded || idx < ITEMS_NUMBER_WHEN_COLLAPSED) && (React.createElement(CardDeChamado, { key: chamado.id, chamado: chamado, onClick: function () { return handleOnItemClick(chamado); } }));
        }),
        (chamados === null || chamados === void 0 ? void 0 : chamados.length) > ITEMS_NUMBER_WHEN_COLLAPSED && (React.createElement(LoadMoreInfo, { onClick: function () { return setExpanded(!isExpanded); } },
            "Ver ",
            isExpanded ? 'menos' : 'mais'))));
};
